/**
 * Closed id patterns for Screen IR.
 * Dotted product.area.verb style is preferred; single segments allowed for legacy inventory ids.
 */

export const SCREEN_ID_RE = /^[a-z][a-z0-9]*(?:[.-][a-z0-9]+)*$/
export const ACTION_ID_RE = /^[a-z][a-z0-9]*(?:[.-][a-z0-9]+)*$/
export const INTENT_ID_RE = /^[a-z][a-z0-9]*(?:[.-][a-z0-9]+)*$/

export type IdKind = 'screen' | 'action' | 'intent'

const PATTERNS: Record<IdKind, RegExp> = {
  screen: SCREEN_ID_RE,
  action: ACTION_ID_RE,
  intent: INTENT_ID_RE,
}

export function assertId(kind: IdKind, value: string): string {
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Invalid ${kind} id: empty`)
  }
  if (!PATTERNS[kind].test(value)) {
    throw new Error(
      `Invalid ${kind} id "${value}": must match ${PATTERNS[kind]} (dotted product.area.verb or kebab segment)`,
    )
  }
  return value
}

export function isValidId(kind: IdKind, value: string): boolean {
  return typeof value === 'string' && value.length > 0 && PATTERNS[kind].test(value)
}
